import type { TOC } from '@ember/component/template-only'
import { SideNavProductGroup } from 'teacher-ui-client/components/side-nav/product-group'
import { ReadingEggspressReportsAccordion } from 'teacher-ui-client/components/side-nav/reading/reading-eggspress-reports-accordion'

export const ReadingEggspressProductGroup: TOC<unknown> = <template>
  <SideNavProductGroup @product="reading-eggspress" class="bg-rexy-purple-50 rounded-lg">
    <ReadingEggspressReportsAccordion />
  </SideNavProductGroup>
</template>

export default ReadingEggspressProductGroup
